import { render, staticRenderFns } from "./coverAll.vue?vue&type=template&id=4baf319c&scoped=true&"
import script from "./coverAll.vue?vue&type=script&lang=js&"
export * from "./coverAll.vue?vue&type=script&lang=js&"
import style0 from "./coverAll.vue?vue&type=style&index=0&id=4baf319c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf319c",
  null
  
)

export default component.exports